import * as Types from "../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type ListCuratedSpacesSmallQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ListCuratedSpacesSmallQuery = {
  listCuratedSpaces: Array<{ __typename: "CuratedSpaces"; slug: string }>;
};

export type ListCuratedSpacesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ListCuratedSpacesQuery = {
  listCuratedSpaces: Array<{
    __typename: "CuratedSpaces";
    slug: string;
    owner: string;
    created: string;
    published: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    draft: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    metadata: {
      __typename: "CuratedSpaceMetadata";
      name: string;
      description: string;
    } | null;
  }>;
};

export type GetPublicCuratedSpaceQueryVariables = Types.Exact<{
  getPublicCuratedSpaceId: Types.Scalars["String"];
}>;

export type GetPublicCuratedSpaceQuery = {
  getPublicCuratedSpace: {
    __typename: "CuratedSpaces";
    slug: string;
    owner: string;
    created: string;
    published: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    draft: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    metadata: {
      __typename: "CuratedSpaceMetadata";
      name: string;
      description: string;
    } | null;
  } | null;
};

export type GetCuratedSpaceQueryVariables = Types.Exact<{
  getCuratedSpaceId: Types.Scalars["String"];
}>;

export type GetCuratedSpaceQuery = {
  getCuratedSpace: {
    __typename: "CuratedSpaces";
    slug: string;
    owner: string;
    created: string;
    published: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    draft: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    metadata: {
      __typename: "CuratedSpaceMetadata";
      name: string;
      description: string;
    } | null;
  } | null;
};

export type CreateCuratedSpaceMutationVariables = Types.Exact<{
  data: Types.CreateCuratedSpaceInput;
}>;

export type CreateCuratedSpaceMutation = {
  createCuratedSpace: { __typename: "CuratedSpaces"; slug: string };
};

export type UpdateCuratedSpaceMutationVariables = Types.Exact<{
  data: Types.UpdateCuratedSpaceInput;
  updateCuratedSpaceId: Types.Scalars["String"];
}>;

export type UpdateCuratedSpaceMutation = {
  updateCuratedSpace: {
    __typename: "CuratedSpaces";
    slug: string;
    owner: string;
    created: string;
    published: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    draft: {
      __typename: "CurationData";
      css: string;
      html: string;
      projectData: string | null;
      editorVersion: string;
    } | null;
    metadata: {
      __typename: "CuratedSpaceMetadata";
      name: string;
      description: string;
    } | null;
  };
};

export type PublishCuratedSpaceMutationVariables = Types.Exact<{
  publishCuratedSpaceId: Types.Scalars["String"];
}>;

export type PublishCuratedSpaceMutation = {
  publishCuratedSpace: { __typename: "CuratedSpaces"; slug: string };
};

export type DeleteCuratedSpaceMutationVariables = Types.Exact<{
  deleteCuratedSpaceId: Types.Scalars["String"];
}>;

export type DeleteCuratedSpaceMutation = { deleteCuratedSpace: boolean };

export const ListCuratedSpacesSmallDocument = gql`
  query ListCuratedSpacesSmall {
    listCuratedSpaces {
      slug
    }
  }
`;

/**
 * __useListCuratedSpacesSmallQuery__
 *
 * To run a query within a React component, call `useListCuratedSpacesSmallQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCuratedSpacesSmallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCuratedSpacesSmallQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCuratedSpacesSmallQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListCuratedSpacesSmallQuery,
    ListCuratedSpacesSmallQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListCuratedSpacesSmallQuery,
    ListCuratedSpacesSmallQueryVariables
  >(ListCuratedSpacesSmallDocument, options);
}
export function useListCuratedSpacesSmallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCuratedSpacesSmallQuery,
    ListCuratedSpacesSmallQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListCuratedSpacesSmallQuery,
    ListCuratedSpacesSmallQueryVariables
  >(ListCuratedSpacesSmallDocument, options);
}
export type ListCuratedSpacesSmallQueryHookResult = ReturnType<
  typeof useListCuratedSpacesSmallQuery
>;
export type ListCuratedSpacesSmallLazyQueryHookResult = ReturnType<
  typeof useListCuratedSpacesSmallLazyQuery
>;
export type ListCuratedSpacesSmallQueryResult = Apollo.QueryResult<
  ListCuratedSpacesSmallQuery,
  ListCuratedSpacesSmallQueryVariables
>;
export const ListCuratedSpacesDocument = gql`
  query ListCuratedSpaces {
    listCuratedSpaces {
      slug
      owner
      published {
        css
        html
        projectData
        editorVersion
      }
      draft {
        css
        html
        projectData
        editorVersion
      }
      metadata {
        name
        description
      }
      created
    }
  }
`;

/**
 * __useListCuratedSpacesQuery__
 *
 * To run a query within a React component, call `useListCuratedSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCuratedSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCuratedSpacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCuratedSpacesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListCuratedSpacesQuery,
    ListCuratedSpacesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListCuratedSpacesQuery,
    ListCuratedSpacesQueryVariables
  >(ListCuratedSpacesDocument, options);
}
export function useListCuratedSpacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCuratedSpacesQuery,
    ListCuratedSpacesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListCuratedSpacesQuery,
    ListCuratedSpacesQueryVariables
  >(ListCuratedSpacesDocument, options);
}
export type ListCuratedSpacesQueryHookResult = ReturnType<
  typeof useListCuratedSpacesQuery
>;
export type ListCuratedSpacesLazyQueryHookResult = ReturnType<
  typeof useListCuratedSpacesLazyQuery
>;
export type ListCuratedSpacesQueryResult = Apollo.QueryResult<
  ListCuratedSpacesQuery,
  ListCuratedSpacesQueryVariables
>;
export const GetPublicCuratedSpaceDocument = gql`
  query GetPublicCuratedSpace($getPublicCuratedSpaceId: String!) {
    getPublicCuratedSpace(id: $getPublicCuratedSpaceId) {
      slug
      owner
      published {
        css
        html
        projectData
        editorVersion
      }
      draft {
        css
        html
        projectData
        editorVersion
      }
      metadata {
        name
        description
      }
      created
    }
  }
`;

/**
 * __useGetPublicCuratedSpaceQuery__
 *
 * To run a query within a React component, call `useGetPublicCuratedSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCuratedSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCuratedSpaceQuery({
 *   variables: {
 *      getPublicCuratedSpaceId: // value for 'getPublicCuratedSpaceId'
 *   },
 * });
 */
export function useGetPublicCuratedSpaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicCuratedSpaceQuery,
    GetPublicCuratedSpaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPublicCuratedSpaceQuery,
    GetPublicCuratedSpaceQueryVariables
  >(GetPublicCuratedSpaceDocument, options);
}
export function useGetPublicCuratedSpaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicCuratedSpaceQuery,
    GetPublicCuratedSpaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublicCuratedSpaceQuery,
    GetPublicCuratedSpaceQueryVariables
  >(GetPublicCuratedSpaceDocument, options);
}
export type GetPublicCuratedSpaceQueryHookResult = ReturnType<
  typeof useGetPublicCuratedSpaceQuery
>;
export type GetPublicCuratedSpaceLazyQueryHookResult = ReturnType<
  typeof useGetPublicCuratedSpaceLazyQuery
>;
export type GetPublicCuratedSpaceQueryResult = Apollo.QueryResult<
  GetPublicCuratedSpaceQuery,
  GetPublicCuratedSpaceQueryVariables
>;
export const GetCuratedSpaceDocument = gql`
  query GetCuratedSpace($getCuratedSpaceId: String!) {
    getCuratedSpace(id: $getCuratedSpaceId) {
      slug
      owner
      published {
        css
        html
        projectData
        editorVersion
      }
      draft {
        css
        html
        projectData
        editorVersion
      }
      metadata {
        name
        description
      }
      created
    }
  }
`;

/**
 * __useGetCuratedSpaceQuery__
 *
 * To run a query within a React component, call `useGetCuratedSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCuratedSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCuratedSpaceQuery({
 *   variables: {
 *      getCuratedSpaceId: // value for 'getCuratedSpaceId'
 *   },
 * });
 */
export function useGetCuratedSpaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCuratedSpaceQuery,
    GetCuratedSpaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCuratedSpaceQuery, GetCuratedSpaceQueryVariables>(
    GetCuratedSpaceDocument,
    options
  );
}
export function useGetCuratedSpaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCuratedSpaceQuery,
    GetCuratedSpaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCuratedSpaceQuery,
    GetCuratedSpaceQueryVariables
  >(GetCuratedSpaceDocument, options);
}
export type GetCuratedSpaceQueryHookResult = ReturnType<
  typeof useGetCuratedSpaceQuery
>;
export type GetCuratedSpaceLazyQueryHookResult = ReturnType<
  typeof useGetCuratedSpaceLazyQuery
>;
export type GetCuratedSpaceQueryResult = Apollo.QueryResult<
  GetCuratedSpaceQuery,
  GetCuratedSpaceQueryVariables
>;
export const CreateCuratedSpaceDocument = gql`
  mutation CreateCuratedSpace($data: CreateCuratedSpaceInput!) {
    createCuratedSpace(data: $data) {
      slug
    }
  }
`;
export type CreateCuratedSpaceMutationFn = Apollo.MutationFunction<
  CreateCuratedSpaceMutation,
  CreateCuratedSpaceMutationVariables
>;

/**
 * __useCreateCuratedSpaceMutation__
 *
 * To run a mutation, you first call `useCreateCuratedSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCuratedSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCuratedSpaceMutation, { data, loading, error }] = useCreateCuratedSpaceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCuratedSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCuratedSpaceMutation,
    CreateCuratedSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCuratedSpaceMutation,
    CreateCuratedSpaceMutationVariables
  >(CreateCuratedSpaceDocument, options);
}
export type CreateCuratedSpaceMutationHookResult = ReturnType<
  typeof useCreateCuratedSpaceMutation
>;
export type CreateCuratedSpaceMutationResult =
  Apollo.MutationResult<CreateCuratedSpaceMutation>;
export type CreateCuratedSpaceMutationOptions = Apollo.BaseMutationOptions<
  CreateCuratedSpaceMutation,
  CreateCuratedSpaceMutationVariables
>;
export const UpdateCuratedSpaceDocument = gql`
  mutation UpdateCuratedSpace(
    $data: UpdateCuratedSpaceInput!
    $updateCuratedSpaceId: String!
  ) {
    updateCuratedSpace(data: $data, id: $updateCuratedSpaceId) {
      slug
      owner
      published {
        css
        html
        projectData
        editorVersion
      }
      draft {
        css
        html
        projectData
        editorVersion
      }
      metadata {
        name
        description
      }
      created
    }
  }
`;
export type UpdateCuratedSpaceMutationFn = Apollo.MutationFunction<
  UpdateCuratedSpaceMutation,
  UpdateCuratedSpaceMutationVariables
>;

/**
 * __useUpdateCuratedSpaceMutation__
 *
 * To run a mutation, you first call `useUpdateCuratedSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCuratedSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCuratedSpaceMutation, { data, loading, error }] = useUpdateCuratedSpaceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateCuratedSpaceId: // value for 'updateCuratedSpaceId'
 *   },
 * });
 */
export function useUpdateCuratedSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCuratedSpaceMutation,
    UpdateCuratedSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCuratedSpaceMutation,
    UpdateCuratedSpaceMutationVariables
  >(UpdateCuratedSpaceDocument, options);
}
export type UpdateCuratedSpaceMutationHookResult = ReturnType<
  typeof useUpdateCuratedSpaceMutation
>;
export type UpdateCuratedSpaceMutationResult =
  Apollo.MutationResult<UpdateCuratedSpaceMutation>;
export type UpdateCuratedSpaceMutationOptions = Apollo.BaseMutationOptions<
  UpdateCuratedSpaceMutation,
  UpdateCuratedSpaceMutationVariables
>;
export const PublishCuratedSpaceDocument = gql`
  mutation PublishCuratedSpace($publishCuratedSpaceId: String!) {
    publishCuratedSpace(id: $publishCuratedSpaceId) {
      slug
    }
  }
`;
export type PublishCuratedSpaceMutationFn = Apollo.MutationFunction<
  PublishCuratedSpaceMutation,
  PublishCuratedSpaceMutationVariables
>;

/**
 * __usePublishCuratedSpaceMutation__
 *
 * To run a mutation, you first call `usePublishCuratedSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCuratedSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCuratedSpaceMutation, { data, loading, error }] = usePublishCuratedSpaceMutation({
 *   variables: {
 *      publishCuratedSpaceId: // value for 'publishCuratedSpaceId'
 *   },
 * });
 */
export function usePublishCuratedSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishCuratedSpaceMutation,
    PublishCuratedSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishCuratedSpaceMutation,
    PublishCuratedSpaceMutationVariables
  >(PublishCuratedSpaceDocument, options);
}
export type PublishCuratedSpaceMutationHookResult = ReturnType<
  typeof usePublishCuratedSpaceMutation
>;
export type PublishCuratedSpaceMutationResult =
  Apollo.MutationResult<PublishCuratedSpaceMutation>;
export type PublishCuratedSpaceMutationOptions = Apollo.BaseMutationOptions<
  PublishCuratedSpaceMutation,
  PublishCuratedSpaceMutationVariables
>;
export const DeleteCuratedSpaceDocument = gql`
  mutation DeleteCuratedSpace($deleteCuratedSpaceId: String!) {
    deleteCuratedSpace(id: $deleteCuratedSpaceId)
  }
`;
export type DeleteCuratedSpaceMutationFn = Apollo.MutationFunction<
  DeleteCuratedSpaceMutation,
  DeleteCuratedSpaceMutationVariables
>;

/**
 * __useDeleteCuratedSpaceMutation__
 *
 * To run a mutation, you first call `useDeleteCuratedSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCuratedSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCuratedSpaceMutation, { data, loading, error }] = useDeleteCuratedSpaceMutation({
 *   variables: {
 *      deleteCuratedSpaceId: // value for 'deleteCuratedSpaceId'
 *   },
 * });
 */
export function useDeleteCuratedSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCuratedSpaceMutation,
    DeleteCuratedSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCuratedSpaceMutation,
    DeleteCuratedSpaceMutationVariables
  >(DeleteCuratedSpaceDocument, options);
}
export type DeleteCuratedSpaceMutationHookResult = ReturnType<
  typeof useDeleteCuratedSpaceMutation
>;
export type DeleteCuratedSpaceMutationResult =
  Apollo.MutationResult<DeleteCuratedSpaceMutation>;
export type DeleteCuratedSpaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteCuratedSpaceMutation,
  DeleteCuratedSpaceMutationVariables
>;
